import { getCookie } from 'helpers/cookies';

const useCountry = () => getCookie('geoip');

export default useCountry;
